import axios from "../axios"
import model from "../../model"

export const readRole = async (id) => {
    let res = await axios.get(`/roles/${id}`)
    return model.fromRoleDTO(res.data)
}

export const readRoles = async () => {
    let res = await axios.get(`/roles`)
    return model.fromRolesDTO(res.data)
}
